export interface EmployeeTimeOff {
    hrRef: number
    name: string
    startDate: string
    endDate: string
    status: 'Approved' | 'Pending'
    leaveType: string
    totalHours: number | null
}

export class BidOutlook {
    id!: string
    needPlans!: boolean
    bidBond!: string
    pq!: boolean
    sd!: boolean
    cmGc!: boolean
    bidTypeId!: string
    bidDescription!: string
    ownerId!: string
    planSource!: string
    bidDelivery!: string
    planReceivedDate?: Date
    completionDate?: Date
    completionDays!: number
    bidRangeId!: string
    readyForReview!: boolean
    publicOpening!: boolean
    estimatorTimeOff!: string
    estimatorHrRef!: number
    reviewerHrRef!: number
    anticipatedBidDate?: Date
    bidDate?: Date
    preBidDate?: Date
    mandatory!: boolean
    personGoingHrRef!: number
    davisBaconWages!: boolean
    ais!: boolean
    complete!: boolean
    notes!: string

    laborFadeGain!: number
    costFadeGain!: number
    isNewWeek!: boolean
    estimatorTimeOffNames!: string
    estimatorTimeOffTooltip!: string

    // Additional Details
    noticeToProceed?: Date
    additionalDescription!: string
    competitorIds: number[] = []
    isDeep!: boolean | null
    hasTrafficControl!: boolean | null
    hasDewatering!: boolean | null
    hasBypassPumping!: boolean | null
    hasTightTimeFrame!: boolean | null
    isTightJobSite!: boolean | null
    hasHaulOff!: boolean | null
    hasInsuranceRequirement!: boolean | null
    risk!: number | null

    // TODO: If we remove JsonDateInterceptor, we can deserialize the dates here.
    // protected $deserialize(source: any): void {
    //     this.planReceivedDate = source.planReceivedDate ? new Date(source.planReceivedDate) : undefined
    //     this.completionDate = source.completionDate ? new Date(source.completionDate) : undefined
    //     this.anticipatedBidDate = source.anticipatedBidDate ? new Date(source.anticipatedBidDate) : undefined
    //     this.bidDate = source.bidDate ? new Date(source.bidDate) : undefined
    //     this.preBidDate = source.preBidDate ? new Date(source.preBidDate) : undefined
    //     this.noticeToProceed = source.noticeToProceed ? new Date(source.noticeToProceed) : undefined
    // }
}
